/**
 * Format a value in EUR for display.
 * @param value Amount in EUR (decimal format, e.g. 10.50)
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
}

/**
 * Convert cents to EUR (number).
 * Use this when the value comes from API or database stored in cents.
 * @param cents Amount in cents (e.g. 1050)
 * @returns Amount in EUR (e.g. 10.50) or null if input is invalid
 */
export function convertCentsToEur(cents: number | undefined | null): number | null {
  if (cents == null || isNaN(cents)) {
    return null;
  }
  return cents / 100;
}

/**
 * Format a value in cents for display (converts to EUR then formats).
 * Use this when the value comes from API or database stored in cents.
 * @param cents Amount in cents (e.g. 1050)
 */
export function formatCurrencyFromCents(cents: number | undefined | null): string {
  if (cents == null || isNaN(cents)) {
    return '--';
  }
  const eur = convertCentsToEur(cents);
  if (eur === null) {
    return '--';
  }
  return formatCurrency(eur);
}

export function formatNumber(value: number): string {  
  return new Intl.NumberFormat('fr-FR').format(value);
}

export function getInitials(name: string): string {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('');
  }

